import { render, staticRenderFns } from "./SoundEl.vue?vue&type=template&id=4bbf83fa&"
import script from "./SoundEl.vue?vue&type=script&lang=ts&"
export * from "./SoundEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports